import { Controller } from "stimulus"
export default class extends Controller {
  connect() {
  }
  toggle(){
    this.element.classList.toggle("toggled")
  }
}